import { Select as MSelect } from '@mantine/core';
import classes from './select.module.scss';
import { IconChevronDown } from '@tabler/icons-react';

export const Select = MSelect.extend({
  classNames: classes,
  styles: {
    option: {
      padding: '0.75rem',
    },
  },
});

Select.defaultProps = {
  rightSection: <IconChevronDown size={20} />,
};
